import { DiscoveryApi, FetchApi } from '@backstage/frontend-plugin-api';
import {
  DefaultApiClient,
  DefaultApiResponse,
} from '@internal/backstage-plugin-devops-react/';
import { CveApi } from './CveApi';

export class CveApiClient extends DefaultApiClient implements CveApi {
  public constructor(options: {
    discoveryApi: DiscoveryApi;
    fetchApi: FetchApi;
  }) {
    super({
      backendName: 'devops-cve',
      ...options,
    });
  }

  async getGithubCve(): Promise<DefaultApiResponse> {
    const urlSegment = `v2/github_cve`;
    return await this.get(urlSegment);
  }

  async getRedhatCve(): Promise<DefaultApiResponse> {
    const urlSegment = `v2/redhat_cve`;
    return await this.get(urlSegment);
  }
}
